import { Component } from 'react'

import * as util from 'x/utils/util'

import { IQtyAdjustReason, ISelectedStoreMap, IXScreenProps, IXSegmentOption } from 'x/index'

interface IFileUpload {
  name: string
  lastModified: number
  webkitRelativePath: string
  size: number
  type: string
  path: string
}

export interface BaseImportAddProductWarehouseBySKUProps extends IXScreenProps {
  selectedStore: ISelectedStoreMap
}

export interface BaseImportAddProductWarehouseBySKUState {
  fileUpload: IFileUpload
  disabledDownloadTemplate: boolean
  isLoading: boolean

  note?: string
  refCode?: string
  orderId?: string
  selectedReason: IXSegmentOption<IQtyAdjustReason>
  isFillExtraDataExpanded: boolean

  errMessage?: string
}

// interface IImportExcelMenuItem {
//   label: string
//   iconName?: string
//   iconFamily?: 'Ionicons' | 'FontAwesome' | 'MaterialIcons' | 'MaterialCommunityIcons' | 'AntDesign' | 'Foundation'
//   iconStyle?: Object
//   nav?: () => void
//   perm?: string | string[]
//   isHeader?: boolean
//   permBitIndex?: number
// }

export default abstract class BaseImportAddProductWarehouseBySKU extends Component<
  BaseImportAddProductWarehouseBySKUProps,
  BaseImportAddProductWarehouseBySKUState
> {
  // abstract async handleOnDownloadFile(url: string, fileName: string): Promise<void>
  inProcess: boolean

  constructor(props) {
    super(props)
    this.state = {
      fileUpload: null,
      disabledDownloadTemplate: false,
      isLoading: false,
      note: '',
      refCode: '',
      orderId: '',
      selectedReason: null,
      isFillExtraDataExpanded: false, // default to collapsed

      errMessage: '',
    }
    this.inProcess = false
  }

  _goBack = () => {
    util.navGoBack(this.props)
  }

  _setFileUpload = (acceptedFiles: IFileUpload[]) => {
    // console.log(acceptedFiles)
    util.setStatePromise(this, {
      fileUpload: acceptedFiles[0],
    })
  }

  _startLoading = async () => {
    this.inProcess = true
    await util.setStatePromise(this, {
      isLoading: true,
    })
  }

  _stopLoading = async () => {
    this.inProcess = false
    await util.setStatePromise(this, {
      isLoading: false,
    })
  }
}
